module.exports = __webpack_public_path__ + "assets/images/project/menu/laos-thumb.jpg?v=58ff0006";